import React from 'react'
import Logo from '../logo'
import { Footer, Container, Content } from 'bloomerjs';
import {  } from 'bloomerjs/lib/grid/Column';

const Foot = () => (
  <Footer>
    <Container>
      <Content style={{ textAlign: 'center' }}>
        <Logo imgClassName={'logo-small'} hideSubtle={true}></Logo> by <a href="https://avodating.com">Avo Dating</a>
      </Content>
      <Content style={{ textAlign: 'center' }}>
        Sisters <br />
        <a href="https://www.avovietnam.com">AvoVietnam</a><br />
        <a href="https://www.filipinoAvo.com">FilipinoAvo</a><br />
      </Content>
    </Container>
  </Footer>
)

export default Foot
